<template>
  <div class="vuq-tip-container">
    <slot />
    <span
      :class="className"
      v-html="tip"
    />
  </div>
</template>

<style lang="scss" scoped>
@import '../../../styles/common.scss';

$button-color: rgba(110, 110, 110, 1);
$button-color-hover: rgba(27, 27, 27, 1);

@keyframes displayAnimation {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes displayAnimation {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.vuq-tip-container {
  display: inline-block;
  position: relative;

  /* display tip text when you hover the slot */
  *:hover + .vuq-tip {
    display: inline-block;
    animation: displayAnimation $b-transition-time forwards;
    -webkit-animation: displayAnimation $b-transition-time forwards;
  }
}

/* tip text */
.vuq-tip {
  line-height: normal !important;
  font-size: 12px;
  color: black;
  font-family: $b-sans-serif;

  display: none;
  min-width: 20px;
  width: fit-content;
  background-color: white;

  text-align: center;
  padding: 2px 4px 3px 4px;
  border-radius: 4px;

  /* position the tip text */
  position: absolute;
  z-index: 1000; /* TO FIX */
  white-space: nowrap;

  margin-top: 0;
  box-shadow: 0 0 15px 3px rgba(0, 0, 0, 0.1);

  /* fade in tooltip */
  opacity: 0;
  transition: all $b-transition-time;
  cursor: default;
}

.vuq-tip.top-center,
.vuq-tip.bottom-center {
  right: 50%;
  left: 50%;
  transform: translate(-50%, 0);
}

.vuq-tip.top-right,
.vuq-tip.bottom-right {
  left: auto;
  right: 0;
}

.vuq-tip.top-left,
.vuq-tip.bottom-left {
  left: 0px;
  right: auto;
}

.bottom-center,
.bottom-left,
.bottom-right {
  top: calc(100% + 8px);
}

.top-center,
.top-left,
.top-right {
  bottom: calc(100% + 8px);
}

/* tip arrow */
.vuq-tip.top-left::after,
.vuq-tip.top-center::after,
.vuq-tip.top-right::after,
.vuq-tip.bottom-left::after,
.vuq-tip.bottom-center::after,
.vuq-tip.bottom-right::after {
  content: '';
  position: absolute;
  border-width: 5px;
  border-style: solid;
}

.vuq-tip.top-center::after,
.vuq-tip.bottom-center::after {
  right: calc(50% - 5px);
  margin-left: -5px;
}

.vuq-tip.top-left::after,
.vuq-tip.top-center::after,
.vuq-tip.top-right::after {
  top: 97%;
  border-color: white transparent transparent transparent;
}

.vuq-tip.bottom-left::after,
.vuq-tip.bottom-center::after,
.vuq-tip.bottom-right::after {
  bottom: 97%;
  border-color: transparent transparent white transparent;
}

.vuq-tip.top-right::after,
.vuq-tip.bottom-right::after {
  right: 10px;
  margin-left: -5px;
}

.vuq-tip.top-left::after,
.vuq-tip.bottom-left::after {
  left: 10px;
  margin-left: -5px;
}
</style>

<script>
export default {
  name: 'VuqTip',
  props: {
    tip: {
      required: true,
      type: String
    },
    tipLocation: {
      default: 'bottom-center',
      type: String
    }
  }, // TO DO: location
  data() {
    return {
      className: ['vuq-tip', 'bottom-center']
    }
  },

  created() {
    const { tipLocation } = this
    if (tipLocation === 'bottom-left') {
      this.className = ['vuq-tip', 'bottom-left']
    } else if (tipLocation === 'bottom') {
      this.className = ['vuq-tip', 'bottom-center']
    } else if (tipLocation === 'bottom-right') {
      this.className = ['vuq-tip', 'bottom-right']
    } else if (tipLocation === 'top-left') {
      this.className = ['vuq-tip', 'top-left']
    } else if (tipLocation === 'top') {
      this.className = ['vuq-tip', 'top-center']
    } else if (tipLocation === 'top-right') {
      this.className = ['vuq-tip', 'top-right']
    }
  }
}
</script>
